import {Component} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {LeaguesService} from "../../services/leagues.service";
import {League} from "../../model/league";

@Component({
  selector: 'app-create-league-dialog',
  templateUrl: './create-league-dialog.component.html',
  styleUrls: ['./create-league-dialog.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
  ]
})
export class CreateLeagueDialogComponent {

  formData: UntypedFormGroup = new UntypedFormGroup({
    url: new UntypedFormControl('', [Validators.required]),
    licenced: new UntypedFormControl(false),
  });
  saving = false;

  constructor(
    private leaguesService: LeaguesService,
    private dialogRef: MatDialogRef<CreateLeagueDialogComponent>,
  ) {
  }

  async create(): Promise<void> {
    if (!this.formData.valid || this.saving) {
      return;
    }
    this.saving = true;
    const raw = this.formData.getRawValue();
    // A new league is saved under a placeholder id ('new'); ball-score-server
    // fetches WBSC, then re-keys it to leagues/{tournamentId}, filling
    // name/federation/logos/teams in place.
    const league: League = {
      id: 'new',
      url: (raw.url ?? '').trim(),
      licenced: !!raw.licenced,
      name: '',
      federation: '',
      teams: [],
      availableComponents: ['status'],
    };
    try {
      await this.leaguesService.addOrUpdateLeague(league);
      this.dialogRef.close(true);
    } finally {
      this.saving = false;
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
